import { useState } from "react";
import { useSession } from "../../state/session";
import { useAuthConfig } from "../../state/useAuthConfig";
import { AuthCard } from "./AuthCard";
import { TERMS_NOT_AGREED, TermsAgreement } from "./TermsAgreement";

/** Shown instead of the app to someone signed in whose agreement to the current
 *  terms is missing (accounts from before terms existed) or older (new terms
 *  published). Accepting stores it on the server and opens the app. */
export function UpdatedTermsScreen() {
  const { user, acceptTerms, logout } = useSession();
  const config = useAuthConfig();
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const first = !user?.terms_version;

  const submit = async () => {
    if (!agreed) { setError(TERMS_NOT_AGREED); return; }
    if (!config.terms_version) return;
    setBusy(true);
    setError("");
    try { await acceptTerms(config.terms_version); }
    catch (e) { setError((e as Error).message); setBusy(false); }
  };

  return (
    <AuthCard>
      <h1>{first ? "Terms of Service" : "Updated Terms of Service"}</h1>
      <div className="sub" data-testid="updated-terms">
        {first
          ? "To keep using Model Bench, please read and agree to the ModelBench Terms of Service."
          : "We have updated the ModelBench Terms of Service. Please read and agree to them to keep using Model Bench."}
      </div>
      <TermsAgreement config={config} agreed={agreed} onChange={setAgreed} />
      <div className="error-text" role="alert" data-testid="terms-error">{error}</div>
      <button className="btn primary" disabled={busy || !config.terms_version} onClick={submit} data-testid="terms-accept">Agree and continue</button>
      <div className="switch"><button className="btn flat" onClick={logout} data-testid="terms-logout">Sign out</button></div>
    </AuthCard>
  );
}
